import type { LucideIcon } from 'lucide-react';
import { Circle } from 'lucide-react';
import * as Icons from 'lucide-react';
import { cn } from '@/lib/utils';

export function NavIcon({
  name,
  className,
}: {
  name?: string | null;
  className?: string;
}) {
  if (!name?.trim()) {
    return (
      <Circle
        className={cn('h-5 w-5 shrink-0 opacity-35', className)}
        aria-hidden
      />
    );
  }
  const Icon = (Icons as unknown as Record<string, LucideIcon | undefined>)[
    name.trim()
  ];
  if (!Icon) {
    return (
      <Circle
        className={cn('h-5 w-5 shrink-0 opacity-35', className)}
        aria-hidden
      />
    );
  }
  return <Icon className={cn('h-5 w-5 shrink-0', className)} aria-hidden />;
}
